import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const HelpAndFaqsIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.1088 3.9917H21.2089C22.3135 3.9917 23.2089 4.88713 23.2089 5.9917V7.53967M2.79102 12.4181V17.9618H14.1088M23.2089 16.8531V17.9618H16.3263"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
      />
      <path
        d="M14.1091 17.9614H1.93134C1.41698 17.9614 1 18.3784 1 18.8928V18.8928C1 20.9502 2.66791 22.6181 4.72537 22.6181H21.2746C23.3321 22.6181 25 20.9502 25 18.8928V18.8928C25 18.3784 24.583 17.9614 24.0687 17.9614H16.3266"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
      />
      <path
        d="M14.1094 7.5395L14.1094 4.43503C14.1094 3.70022 13.5137 3.10454 12.7789 3.10454V3.10454C12.0441 3.10454 11.4484 2.50885 11.4484 1.77405L11.4484 1.661C11.4484 1.0299 10.6955 0.70274 10.2342 1.13335L8.69848 2.56665C8.32814 2.9123 7.84043 3.10454 7.33384 3.10454L3.24797 3.10454C2.1434 3.10454 1.24797 3.99996 1.24797 5.10453L1.24797 10.418C1.24797 11.5225 2.1434 12.418 3.24797 12.418L11.4484 12.418"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
      />
      <path
        d="M11.4492 9.53955C11.4492 8.43498 12.3446 7.53955 13.4492 7.53955L14.1102 7.53955L22.3106 7.53955C23.4152 7.53955 24.3106 8.43498 24.3106 9.53955V14.853C24.3106 15.9576 23.4152 16.853 22.3106 16.853H18.2248C17.7182 16.853 17.2305 17.0452 16.8601 17.3909L15.3244 18.8242C14.8631 19.2548 14.1102 18.9276 14.1102 18.2965V18.1835C14.1102 17.4487 13.5145 16.853 12.7797 16.853V16.853C12.0449 16.853 11.4492 16.2573 11.4492 15.5225V9.53955Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
      />
      <path
        d="M6.40945 10.0391H5.24023L7.02178 4.87842H8.42787L10.2069 10.0391H9.03768L7.74498 6.05772H7.70467L6.40945 10.0391ZM6.33638 8.01061H9.09815V8.86233H6.33638V8.01061Z"
        fill="#161616"
      />
      <path
        d="M17.478 12.8414H18.4053L18.8715 13.4411L19.3301 13.9753L20.1944 15.0589H19.1764L18.5817 14.3281L18.2768 13.8947L17.478 12.8414ZM20.2726 12.0552C20.2726 12.618 20.1659 13.0967 19.9525 13.4915C19.7409 13.8863 19.4519 14.1878 19.0857 14.3962C18.7212 14.6028 18.3113 14.7061 17.856 14.7061C17.3974 14.7061 16.9858 14.6019 16.6213 14.3936C16.2567 14.1853 15.9686 13.8838 15.757 13.489C15.5453 13.0942 15.4395 12.6163 15.4395 12.0552C15.4395 11.4924 15.5453 11.0137 15.757 10.6189C15.9686 10.2241 16.2567 9.92339 16.6213 9.71676C16.9858 9.50845 17.3974 9.4043 17.856 9.4043C18.3113 9.4043 18.7212 9.50845 19.0857 9.71676C19.4519 9.92339 19.7409 10.2241 19.9525 10.6189C20.1659 11.0137 20.2726 11.4924 20.2726 12.0552ZM19.1663 12.0552C19.1663 11.6907 19.1117 11.3832 19.0025 11.1329C18.895 10.8826 18.743 10.6928 18.5465 10.5634C18.3499 10.4341 18.1198 10.3694 17.856 10.3694C17.5923 10.3694 17.3621 10.4341 17.1656 10.5634C16.969 10.6928 16.8161 10.8826 16.7069 11.1329C16.5994 11.3832 16.5457 11.6907 16.5457 12.0552C16.5457 12.4197 16.5994 12.7272 16.7069 12.9775C16.8161 13.2278 16.969 13.4176 17.1656 13.547C17.3621 13.6763 17.5923 13.741 17.856 13.741C18.1198 13.741 18.3499 13.6763 18.5465 13.547C18.743 13.4176 18.895 13.2278 19.0025 12.9775C19.1117 12.7272 19.1663 12.4197 19.1663 12.0552Z"
        fill="#161616"
      />
    </svg>
  );
};

export default HelpAndFaqsIcon;
